import { chakra } from '@chakra-ui/react';
import React from 'react';

import { IconButton } from 'toolkit/chakra/icon-button';
import IconSvg from 'ui/shared/IconSvg';

interface Props {
  loading?: boolean;
  className?: string;
}

const OPEN_STYLES = {
  color: 'text.primary',
  backgroundColor: { _light: 'defaultBlack.100', _dark: 'defaultBlack.700' },
};

const AdditionalInfoButton = (props: Props, ref: React.ForwardedRef<HTMLButtonElement>) => {
  const { loading, ...rest } = props;

  return (
    <IconButton
      overflow="visible"
      minW="32px"
      minH="32px"
      ref={ ref }
      color="icon.info"
      borderRadius="full"
      _hover={ OPEN_STYLES }
      _open={ OPEN_STYLES }
      aria-label="Transaction info"
      boxSize={ 6 }
      loadingSkeleton={ loading }
      { ...rest }
    >
      <IconSvg zIndex={ 2 } name="info" boxSize={ 5 }/>
    </IconButton>
  );
};

export default chakra(React.forwardRef(AdditionalInfoButton));
